document.addEventListener('DOMContentLoaded', function () {
  const tabTarget = document.querySelector('.main-product-tab');
  const tabModule = document.querySelector('.product-tab-module');
  const firstMenu = document.querySelector('.first-menu');
  const secondMenu = document.querySelector('.second-menu');

  if (!tabTarget || !tabModule) return;

  // 节流，避免滚动太频繁
  function throttle(func, delay = 150) {
    let timer = null;
    return (...args) => {
      if (!timer) {
        timer = setTimeout(() => {
          func.apply(this, args);
          timer = null;
        }, delay);
      }
    };
  }

  function handleScroll() {
    const tabTop = tabTarget.getBoundingClientRect().top;
    // 判断是否滚到 tab 下面
    if (tabTop < 0) {
      tabModule.classList.add('active');
      firstMenu?.classList.add('hide');
      secondMenu?.classList.add('hide');
    } else {
      tabModule.classList.remove('active');
      firstMenu?.classList.remove('hide');
      secondMenu?.classList.remove('hide');
    }
  }

  window.addEventListener('scroll', throttle(handleScroll));
  handleScroll(); // 初始执行一次






   const tabs = document.querySelectorAll('.new_sed_menu');
  const headerHeight = document.querySelector('.header') 
    ? document.querySelector('.header').offsetHeight 
    : 80;
  const tabBarHeight = document.querySelector('.custom-tabs-content')
    ? document.querySelector('.custom-tabs-content').offsetHeight
    : 60;
  const offset = headerHeight + tabBarHeight;
  
  let isScrolling = false;
  let scrollTimeout;
  
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetId = tab.getAttribute('href');
      const targetEl = document.querySelector(targetId);
      
      if (!targetEl) return;
      
      tabs.forEach(function(t) { t.classList.remove('active'); });
      tab.classList.add('active');
      
      isScrolling = true;
      
      const targetPosition = targetEl.offsetTop - offset;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        isScrolling = false;
      }, 800);
    });
  });
  
  function updateActiveTab() {
    if (isScrolling) return;
    
    let currentId = '';
    
    tabs.forEach(function(tab) {
      const targetId = tab.getAttribute('href');
      const targetEl = document.querySelector(targetId);
      
      if (targetEl) {
        const rect = targetEl.getBoundingClientRect();
        if (rect.top <= offset + 100) {
          currentId = targetId;
        }
      }
    });
    
    if (currentId) {
      tabs.forEach(function(tab) {
        if (tab.getAttribute('href') === currentId) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
    }
  }
  
  window.addEventListener('scroll', updateActiveTab);
  updateActiveTab();
  
});